<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.integralActivityList.push"
    :is-show-search-input="true"
    search-placeholder="输入活动名称进行搜索"
  >
    <v-column-time/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="活动类型">
      <template v-slot="{ row }">
        <el-tag
          v-for="activityType in findIntegralActivityType(row.activity_type)"
          :key="`activityType${activityType.value}`"
          :type="activityType.type"
        >{{ activityType.name }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="活动标题" prop="title"/>

    <el-table-column label="积分奖励">
      <template v-slot="{ row }">
        <template v-if="row.activity_type === integralActivityTypes.double.value">
          {{ row.integral | toYuan }}
        </template>
        <span v-else class="info-color">以目标为准</span>
      </template>
    </el-table-column>

    <el-table-column label="开始时间" prop="summary">
      <template v-slot="{ row }">
        <template v-if="row.activity_type === integralActivityTypes.double.value">
          {{ row.start_time | timeToYmdHi }}
        </template>
        <span v-else class="info-color">以目标为准</span>
      </template>
    </el-table-column>
    <el-table-column label="结束时间" prop="summary">
      <template v-slot="{ row }">
        <template v-if="row.activity_type === integralActivityTypes.double.value">
          {{ row.end_time | timeToYmdHi }}
        </template>
        <span v-else class="info-color">以目标为准</span>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="280">
      <template v-slot="{ row }">

        <v-list-button v-if="isAdministrator" :to="RouteConfig.integralActivityEdit.to(row.id)"/>

        <v-popover v-if="isAdministrator">
          <v-popover-item
            icon="bin"
            name="删除活动"
            @click="handleDelete(row.id, row.update_time)"
            :is-loading="isDeleting[row.id]"
            message="确定要删除此活动吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`integral-activity-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>活动类型</span>
              <div class="list-item-info">
                <el-tag
                  v-for="activityType in findIntegralActivityType(v.activity_type)"
                  :key="`mobile-activity-type-${v.id}-${activityType.value}`"
                  :type="activityType.type"
                >
                  {{ activityType.name }}
                </el-tag>
              </div>
            </div>
            <div class="list-item-detail">
              <span>活动标题</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>积分奖励</span>
              <span v-if="v.activity_type === integralActivityTypes.double.value">{{ v.integral | toYuan }}</span>
              <span v-else class="info-color">以目标为准</span>
            </div>
            <div class="list-item-detail">
              <span>开始时间</span>
              <span v-if="v.activity_type === integralActivityTypes.double.value">{{ v.start_time | timeToYmdHi }}</span>
              <span v-else class="info-color">以目标为准</span>
            </div>
            <div class="list-item-detail">
              <span>结束时间</span>
              <span v-if="v.activity_type === integralActivityTypes.double.value">{{ v.end_time | timeToYmdHi }}</span>
              <span v-else class="info-color">以目标为准</span>
            </div>
            <div class="list-item-button">
              <v-list-button v-if="isAdministrator" :to="RouteConfig.integralActivityEdit.to(v.id)"/>
              <v-popover v-if="isAdministrator">
                <v-popover-item
                  icon="bin"
                  name="删除活动"
                  @click="handleDelete(v.id, v.update_time)"
                  :is-loading="isDeleting[v.id]"
                  message="确定要删除此活动吗？"
                />
              </v-popover>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/integral-activity';
import { integralActivityTypes, findIntegralActivityType } from "@/enums/integralActivityTypes";

export default {
  name: RouteConfig.integralActivityList.name,
  data: () => ({
    RouteConfig,
    integralActivityTypes,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findIntegralActivityType,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete(id, update_time) {
      if (!id) return this.$message.warning('缺少活动 ID，无法删除该活动！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
